import React from "react";
import FilterData from "../../api/FilterData";
import iconRemoveFilter from "../../img/icons/remove_filter_v3.png";
import iconNoProductionFilter from "../../img/icons/icon_no_production.png";
import { observer } from "mobx-react-lite";
import Memory from "../../api/Memory";

export const FilterBarClient = observer(
  ({
    setIdSearch,
    setVersionFilterOn,
    onResetVersionUi,
    v4Layout,
    showNoProductionFilter = true,
  }) => {
    const showNullProduction = () => {
      FilterData.sortSoftProductionNull();
    };
    const showAllClientsFunc = () => {
      setIdSearch("");
      FilterData.showAllClients();
      sessionStorage.removeItem("soft_version");
      sessionStorage.removeItem("condition_version_client");
      Memory.setVersionReduction(2);
      setVersionFilterOn(false);
      onResetVersionUi?.();
    };

    const noSiteFilterActive =
      Memory.var_filter_by_production === "Без площадки";

    if (v4Layout) {
      return (
        <div className="filters-bar-actions">
          {Memory.var_filter_by_production !== null ? (
            <span className="cc-v4-filter-chip">
              Площадка: {Memory.var_filter_by_production}
            </span>
          ) : null}
          {Memory.select_day_period ? (
            <span className="cc-v4-filter-chip">
              Период: {Memory.day_active_lic}
            </span>
          ) : null}
          <button
            type="button"
            className="btn-secondary-v4"
            onClick={showAllClientsFunc}
          >
            Сбросить фильтры
          </button>
          {showNoProductionFilter ? (
            <button
              type="button"
              className={
                noSiteFilterActive
                  ? "btn-outline-v4 cc-v4-btn-compact cc-v4-filter-target-active"
                  : "btn-outline-v4 cc-v4-btn-compact"
              }
              onClick={showNullProduction}
              title="Клиенты без площадки"
            >
              Без площадки
            </button>
          ) : null}
        </div>
      );
    }

    return (
      <div className="client_filterbar_container">
        {Memory.var_filter_by_production !== null ? (
          <span className="client_filterbar_production">
            Площадка: {Memory.var_filter_by_production}
          </span>
        ) : (
          null
        )}
        {Memory.select_day_period ? (
          <span className="client_filterbar_production">
            Период: {Memory.day_active_lic}
          </span>
        ) : (
          null
        )}
        <label className="client_filterbar_show_no_production_container">
          <img
            className="client_filterbar_show_all_client_img"
            src={iconNoProductionFilter}
            alt=""
            onClick={showNullProduction}
          />
          <span className="client_filterbar_show_no_production_span">
            Клиенты без площадки
          </span>
        </label>
        <label className="client_filterbar_show_all_client_container">
          <img
            className="client_filterbar_show_all_client_img"
            src={iconRemoveFilter}
            alt=""
            onClick={showAllClientsFunc}
          />
          <span className="client_filterbar_show_all_client_span">
            Сбросить все фильтры
          </span>
        </label>
      </div>
    );
  }
);
